const sessionLanguages: { audio: string | null; subtitles: string | null } = {
    audio: null,
    subtitles: null,
};

export const getSessionAudioLanguage = (): string | null => sessionLanguages.audio;

export const getSessionSubtitlesLanguage = (): string | null => sessionLanguages.subtitles;

export const setSessionAudioLanguage = (language: string | null) => {
    sessionLanguages.audio = language;
};

export const setSessionSubtitlesLanguage = (language: string | null) => {
    sessionLanguages.subtitles = language;
};

export const clearSessionLanguages = () => {
    sessionLanguages.audio = null;
    sessionLanguages.subtitles = null;
};
